// extracted by mini-css-extract-plugin
module.exports = {"picker":"ColorPicker_picker__1AIpm","wrapper":"ColorPicker_wrapper__iwn_h","colors":"ColorPicker_colors__1OoDF","picker_active":"ColorPicker_picker_active__27mRw"};